import { requestToken, requestTokenImage } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api`;

class CommonServices {
  async AddOffer(formData) {
    try {
      let action = API_ROUTE + "/addOffer-data";
      const response = await requestTokenImage.post(action, formData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async UpdateOffer(formData) {
    try {
      let action = API_ROUTE + "/updateOffer-data";
      const response = await requestTokenImage.post(action, formData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default CommonServices;
